import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'Welcome',
  title: 'Welcome',
  category: 'Utils',
  unique: true,
  icon: Icon,
  version: '1.0.0',
  description: `The module to be shown on the first time the user signs in`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
